import gql from 'graphql-tag';

type Element = {
  action: 'LOG_IN_TO_EXISTING_ACCOUNT' | 'CREATE_ACCOUNT_AND_CHECKOUT';
  id: string;
};

export type EmailAccountAssociationResponse = {
  wesCheckoutsResponse: {
    elements: Element[];
    paging: Record<string, unknown>;
    linked: Record<string, unknown>;
    __typename: 'wesCheckoutsV1';
  };
  errors: unknown;
};

export type EmailAccountAssociationVariables = {
  id: string;
  input: Record<string, unknown>;
};

// Create new endpoint: https://coursera.atlassian.net/browse/DEGMKT-353
export const EMAIL_ACCOUNT_ASSOCIATION = gql`
  mutation WesCheckouts($id: String!, $input: DataMap) {
    wesCheckoutsResponse(id: $id, input: $input)
      @rest(method: "GET", type: "wesCheckoutsV1", path: "wesCheckouts.v1/{args.id}?fields=action") {
      elements {
        action
        id
      }
      paging
      linked
    }
  }
`;
